import { render, staticRenderFns } from "./wysp.vue?vue&type=template&id=3cd6c648&scoped=true"
import script from "./wysp.vue?vue&type=script&lang=js"
export * from "./wysp.vue?vue&type=script&lang=js"
import style0 from "./wysp.vue?vue&type=style&index=0&id=3cd6c648&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd6c648",
  null
  
)

export default component.exports